import PropTypes from 'prop-types';
import React from 'react';
import { Row, Col, Image } from 'react-bootstrap';
import isEqual from 'is-equal';
import cx from 'classnames';
import _ from 'lodash';
import InfiniteScroll from 'react-infinite-scroller';

import InputField from 'src/legacy/components/InputField';
import ImageEditor from 'src/legacy/components/ImageEditor/index.jsx';
import Button from 'src/components/button';

import styles from './RolodexContactForm.module.scss';
import ContactsImportContainer from '../import';

import userRoleService from 'src/utils/userRoles.service.js';
import { localizedStrings } from 'src/localization';
import DOMPurify from 'dompurify';
class RolodexContactForm extends React.Component {
  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props);

    this.state = this.getInitialState();

    this._handleCancelClick = this._handleCancelClick.bind(this);
    this._handleBackClick = this._handleBackClick.bind(this);
    this._handleCreateClick = this._handleCreateClick.bind(this);

    this._handleChange = this._handleChange.bind(this);
    this._handleUploadContactImage = this._handleUploadContactImage.bind(this);
    this.onImageChange = this.onImageChange.bind(this);
    this.onUploadCancel = this.onUploadCancel.bind(this);
    this._handleImportClick = this._handleImportClick.bind(this);
    this.handleSelectClick = this.handleSelectClick.bind(this);
    this.loadMoreOrganizations = this.loadMoreOrganizations.bind(this);

    this.localizedCommons = localizedStrings.commons;
    this.localizedCommonLoading = this.localizedCommons.loading;
    this.localizedCommonActions = this.localizedCommons.actions;
    this.localizedContactSlider = this.localizedCommons.sliders.contacts;
    this.localizedUpdateContact = this.localizedContactSlider.update_contact;
  }

  getInitialState() {
    return {
      editing: false,
      firstName: '',
      lastName: '',
      email: '',
      title: '',
      company: '',
      workPhone: '',
      mobilePhone: '',
      facebook: '',
      linkedin: '',
      twitter: '',
      instagram: '',
      errors: {},
      tempIcon: null,
      icon: null,
      file: null,
      modifiedDate: '',
      importView: false,
      errorMessage: null
    }
  }

  _handleCreateClick() {
    const errors = this.validateForm();
    if (Object.keys(errors).length != 0) {
      this.setState({
        errors: errors
      });

      return;
    }

    let contact = {
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      email: this.state.email,
      title: this.state.title,
      company: this.state.company,
      workPhone: this.state.workPhone,
      mobilePhone: this.state.mobilePhone,
      facebook: this.state.facebook,
      linkedin: this.state.linkedin,
      twitter: this.state.twitter,
      instagram: this.state.instagram,
      icon: this.state.tempIcon
    }

    if (this.props.contact) {
      contact.id = this.props.contact.id;
      this.props.updateContact(contact).then((data) => {
        this.props.onCancelClick();
      });
    } else {
      this.props.createContact(contact).then((data) => {
        if(!this.props.contactList){
          this._handleBackClick();
          return
        }
        var contacts = this.props.contactList.contacts.map((item) => {
          return item.id;
        });

        contacts = [...contacts, data.payload.id];

        if (data.payload.id) {
          var request = {
            contacts: _.uniqBy(contacts)
          }
          this.props.updateContactList(this.props.contactList.id, request).then((response) => {
            if(response){
              this._handleCancelClick();
            }
          });
        }
      });
    }
  }


  _handleCancelClick() {
    let initialState = this.getInitialState();

    if (this.props.contact) {
      var contact = this.props.contact;
      initialState = Object.assign({}, initialState, {
        ...contact
      });
    }

    this.setState({
      ...initialState
    }, () => {
      this.props.onCancelClick();
    });

  }

  _handleBackClick(){
    this.props.onHideCreateView();
  }

  _handleChange(field, e) {
    if (field == 'company') {
      this.props.invalidateOrganizations();
      if (e.target.value) {
        this.props.fetchOrganizations(e.target.value, 0);
        this.setState({
          query: e.target.value
        })
      }
    }

    this.setState({
      [field]: e.target.value
    });
  }

  validateForm() {
    let errors = {};
    const { firstName, email } = this.state;
    if (!firstName || firstName.trim() == '') {
      errors.firstName = 'Enter a valid name';
    }

    const emailError = this._validateEmail(email);
    if (emailError) {
      errors.email = emailError;
    }

    return errors;
  }

  _validateEmail(email) {
    const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;


    if (!email || email.trim() == '') {
      return 'Enter a valid email';
    }

    if (!regex.test(email)) {
      return 'Enter a valid email';
    }
  }

  hasFieldError(field) {
    return this.state.errors[field];
  }

  renderDoneButtonTitle() {
    if (this.state.editing) {
      if (this.props.updating) {
        return `${this.localizedCommonActions.saving}...`;
      } else {
        return this.localizedCommonActions.save;
      }
    } else {
      if (this.props.creating) {
        return `${this.localizedCommonActions.creating}...`;
      } else {
        return this.localizedCommonActions.create;
      }
    }
  }

  _handleUploadContactImage(e) {
    this.setState({
      file: e.target.files[0]
    })
  }

  _handleImportClick() {
    this.setState({
      importView: true
    });
  }

  onImageChange(icon) {
    this.setState({
      tempIcon: icon,
      file: null,
      errors: {}
    });
  }

  onUploadCancel() {
    this.setState({
      icon: this.state.icon,
      file: null,
      errors: {}
    });
  }

  componentDidMount() {

    if (this.props.contact) {
      let initialState = this.getInitialState();
      const result = _.mapValues(this.props.contact, v => _.isNil(v) ? '' : v)
      initialState = Object.assign({}, initialState, {
        ...result,
        editing: true
      });

      this.state = initialState;
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!isEqual(this.props.contact, nextProps.contact)) {
      let initialState = this.getInitialState();
      if (nextProps.contact) {
        const result = _.mapValues(nextProps.contact, v => _.isNil(v) ? '' : v)
        initialState = Object.assign({}, initialState, {
          ...result,
          editing: true
        });
      }

      this.state = initialState;
    }
    
    if (!isEqual(this.props.isResetView, nextProps.isResetView)) {
      let initialState = this.getInitialState();
      this.setState({
        ...initialState
      });
    }

    if (this.props.errors != nextProps.errors) {
      var errors = this.state.errors;

      if (nextProps.errors && nextProps.errors.errors) {
        nextProps.errors.errors.forEach(error => {
          if (error.field) {
            errors[error.field] = error.message;
          } else {
            errors["email"] = error.message;
          }
        });
      }

      this.setState({
        errors: errors
      })
    }
  }

  handleSelectClick(organization) {
    this.props.invalidateOrganizations();
    this.setState({
      company: organization,
      query: ""
    })
  }

  loadMoreOrganizations() {
    let totalPages = this.props.totalPages;
    let currentPage = this.props.currentPage;
    let nextPage = currentPage + 1;

    if (this.props.loading || nextPage > totalPages) {
      return;
    }

    this.props.fetchOrganizations(this.state.query, nextPage);
  }

  enabledNewOrganization() {

    let organizationExists = _.find(this.props.organizations, (organization) => {
      return organization.name.toLowerCase() === this.state.company.toLowerCase()
    });
    if (organizationExists) {
      return false;
    }
    return true;
  }

  render() {
    return (
      <div className={cx(styles.content, this.props.className)}>
        <div className={styles.background}>&nbsp;</div>
        {!this.state.importView && !this.state.uploadView && userRoleService.canCreateContact() && 
          <Row className={styles.body}>
            
            <Col sm={12} md={12} lg={12} xl={12} className={styles.column}>
            <i className='paperflite-left-arrow' onClick={this._handleBackClick}/>

              <h1 className={styles.pageTitle}>{this.props.contact ? this.localizedContactSlider.actions.update_contact : <span>{this.localizedUpdateContact.create_new_contact}</span>}</h1>
            </Col>
            <Col sm={12} md={12} className={styles.column}>
              <div className={cx(styles.iconContainer)}>

                {!this.state.icon &&
                  <div className={cx(styles.addIconContainer, styles.wrapper)}>
                    <i className="paperflite-add" aria-hidden="true"></i>
                    <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.localizedUpdateContact.actions.add_profile_image) }}></span>
                    <input type="file" id="uploadContactIcon" accept="image/*" onChange={this._handleUploadContactImage}></input>
                  </div>
                }

                {(this.state.tempIcon || this.state.icon) &&
                  <Image src={this.state.tempIcon ? this.state.tempIcon :
                    this.state.icon.thumbnail} />
                }
              </div>
            </Col>

            <Col sm={12} className={styles.fields}>
              <InputField
                className={styles.inputField}
                placeholder={this.localizedUpdateContact.placeholders.first_name}
                errorMessage={this.hasFieldError('firstName')}
                value={this.state.firstName}
                onChange={this._handleChange.bind(this, 'firstName')}
                errorStyle={styles.errorStyle}
              />
            </Col>

            <Col sm={12} className={styles.fields}>
              <InputField
                className={styles.inputField}
                // title={this.localizedUpdateContact.last_name}
                placeholder={this.localizedUpdateContact.placeholders.last_name}
                value={this.state.lastName}
                onChange={this._handleChange.bind(this, 'lastName')}
                errorStyle={styles.errorStyle}
              />
            </Col>

            <Col sm={12} className={styles.fields}>
              <InputField
                className={styles.inputField}
                // title={this.localizedUpdateContact.email}
                placeholder={this.localizedUpdateContact.placeholders.email}
                errorMessage={this.hasFieldError('email')}
                value={this.state.email}
                onChange={this._handleChange.bind(this, 'email')}
                disabled={this.state.editing}
                errorStyle={styles.errorStyle} />
            </Col>

            <Col sm={12} className={styles.fields}>
              <InputField
                className={styles.inputField}
                // title={this.localizedUpdateContact.title}
                placeholder={this.localizedUpdateContact.placeholders.title}
                value={this.state.title}
                onChange={this._handleChange.bind(this, 'title')}
                errorStyle={styles.errorStyle}
              />
            </Col>

            <Col sm={12} className={styles.fields}>
              <InputField
                className={styles.inputField}
                // title={this.localizedUpdateContact.company}
                placeholder={this.localizedUpdateContact.placeholders.company}
                value={this.state.company}
                onChange={this._handleChange.bind(this, 'company')}
                errorStyle={styles.errorStyle} />

              {this.state.query &&
                <div className={styles.organizations}>
                  {this.enabledNewOrganization() &&
                    <div className={styles.addOrganization} onClick={() => this.handleSelectClick(this.state.company)}>
                      <i className="paperflite-add" /> {localizedStrings.formatString(this.localizedUpdateContact.new_organization, this.state.company)}
                    </div>
                  }
                  <InfiniteScroll
                    pageStart={0}
                    initialLoad={false}
                    hasMore={this.props.currentPage < this.props.totalPages}
                    loadMore={this.loadMoreOrganizations}
                    useWindow={false}
                    threshold={200}
                  >
                    {this._renderOrganizations()}
                  </InfiniteScroll>
                </div>
              }
            </Col>

            <Col sm={12} className={styles.fields}>
              <InputField
                className={styles.inputField}
                // title={this.localizedUpdateContact.work_phone}
                placeholder={this.localizedUpdateContact.placeholders.work_phone}
                value={this.state.workPhone}
                onChange={this._handleChange.bind(this, 'workPhone')}
                errorStyle={styles.errorStyle} />
            </Col>

            <Col sm={12} className={styles.fields}>
              <InputField
                className={styles.inputField}
                // title={this.localizedUpdateContact.mobile}
                placeholder={this.localizedUpdateContact.placeholders.mobile}
                value={this.state.mobilePhone}
                onChange={this._handleChange.bind(this, 'mobilePhone')}
                errorStyle={styles.errorStyle}
              />
            </Col>

            <Col sm={12} className={styles.category}>{this.localizedUpdateContact.social_profiles}:</Col>

            <Col sm={12} className={styles.fields}>
              <InputField
                className={styles.inputField}
                // title={this.localizedUpdateContact.facebook}
                placeholder={this.localizedUpdateContact.placeholders.facebook}
                value={this.state.facebook}
                onChange={this._handleChange.bind(this, 'facebook')}
                errorStyle={styles.errorStyle}
              />
            </Col>

            <Col sm={12} className={styles.fields}>
              <InputField
                className={styles.inputField}
                // title={this.localizedUpdateContact.linkedin}
                placeholder={this.localizedUpdateContact.placeholders.linkedin}
                value={this.state.linkedin}
                onChange={this._handleChange.bind(this, 'linkedin')}
                errorStyle={styles.errorStyle}
              />
            </Col>

            <Col sm={12} className={styles.fields}>
              <InputField
                className={styles.inputField}
                // title={this.localizedUpdateContact.twitter}
                placeholder={this.localizedUpdateContact.placeholders.twitter}
                value={this.state.twitter}
                onChange={this._handleChange.bind(this, 'twitter')}
                errorStyle={styles.errorStyle}
              />
            </Col>

            <Col sm={12} className={styles.fields}>
              <InputField
                className={styles.inputField}
                // title={this.localizedUpdateContact.instagram}
                placeholder={this.localizedUpdateContact.placeholders.instagram}
                value={this.state.instagram}
                onChange={this._handleChange.bind(this, 'instagram')}
                errorStyle={styles.errorStyle}
              />
            </Col>
          </Row>
        }

        {!this.state.importView &&
          <div className={styles.actions}>
            <Button 
             text={this.renderDoneButtonTitle()}
             variant='primary'
             onClick={() => { this._handleCreateClick() }}
            />
            <Button
            text={this.localizedCommonActions.cancel}
            onClick={() => { this._handleCancelClick() }}
            
            />
          </div>
        }
          {/* <Button.Tray className={styles.actions}>
            <Button
              onClick={() => { this._handleCreateClick() }}
              title={this.renderDoneButtonTitle()}
              primary
              className={styles.send}
            />
            <Button
              onClick={() => { this._handleCancelClick() }}
              title={this.localizedCommonActions.cancel}
              className={styles.cancel}
            />
          </Button.Tray> */}

        {this.state.importView && 
          <ContactsImportContainer
            handleCancelClick={() => this._handleCancelClick()}
            handleBackClick={() => this._handleBackClick()}
          />
        }

        <ImageEditor className={styles.editor}
          show={this.state.file != null}
          image={this.state.file}
          onChange={this.onImageChange}
          onCancel={this.onUploadCancel}
          borderRadius={20}
          width={400}
          height={400}
        />
      </div>
    );
  }

  _renderOrganizations() {
    var rows = Array();

    this.props.organizations.forEach((organization, index) => {
      rows.push(
        <div className={styles.userRow} key={organization.id} onClick={() => this.handleSelectClick(organization.name)}>
          <div className={styles.name}>
            {organization.name}
          </div>
        </div>
      )
    });

    return rows;
  }
}

export default RolodexContactForm;